import { omit } from '../../../../core/util/utils';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const controlRemoveReducer = (
    state = initialState,
    action: actions.ControlRemove
): State => {
    return {
        ...state,
        dirty: true,
        control: {
            ...state.control,
            ids: state.control.ids
                .filter(id => id !== action.payload.control.id),
            entities: omit(
                state.control.entities,
                action.payload.control.id
            ),
            deleted: [
                ...state.control.deleted,
                action.payload.control
            ]
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-remove.reducer.ts